import {AbstractControl} from '@angular/forms';

export class CurrencyValidation {

    static CurrencyString(AC: AbstractControl) {
        let currency = AC.value;
        let checkMax100 = false;

        if (currency.substr(-1) == '%') {
            currency = currency.substr(0, currency.length - 1);
            checkMax100 = true;
        }

        let firstSumnol = currency.substr(0,1);
        if ( firstSumnol == '-' || firstSumnol == '+' || firstSumnol == '=') {
            currency = currency.substr(1);
        }

        if (checkMax100 && currency > 100) {
            return { 'percent_invalid': true };
        } else {
            if (isNaN(Number(currency)) || !currency.length) {
                return { 'namber_invalid': true};
            } else {
                return null;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/controls/currency-validation.ts